import axiosClient from "@/services/shared/api/axios-client";
import config from "@/config/config";

const API_URL = "/password/forgot";

// Real API implementation
const apiRequestPasswordReset = async (email: string): Promise<void> => {
  await axiosClient.post(API_URL, { email });
};

// Mock implementation
const mockRequestPasswordReset = async (email: string): Promise<void> => {
  console.log("Mock: Requesting password reset for", email);
  await new Promise((resolve) => setTimeout(resolve, 500));
};

// Export service that selects between real and mock implementation
export const requestPasswordReset = config.selectApi(
  apiRequestPasswordReset,
  mockRequestPasswordReset
);
